import { Auth0Roles } from 'models/auth'

interface ChatWidgetAudience {
  isAuthenticated: boolean
  roles: Pick<Auth0Roles, 'isClient'>
  allowChatWidget: boolean
  isEmbed: boolean
  hasPlatformAccount: boolean
}

export const shouldShowChatWidget = ({
  isAuthenticated,
  roles,
  allowChatWidget,
  isEmbed,
  hasPlatformAccount,
}: ChatWidgetAudience): boolean =>
  isAuthenticated && roles.isClient && allowChatWidget && !isEmbed && hasPlatformAccount
